export default __webpack_public_path__ + "static/logo-1-9bebc1c60a675c81305e9bfde8e40707.webp";